export default __webpack_public_path__ + "images/about-well-ageing-cream-desktop.png";